import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import LogoLoader from "../components/Common/LogoLoader";

const SITE_URL = process.env.REACT_APP_WEBSITE_URL
  ? process.env.REACT_APP_WEBSITE_URL.replace(/\/+$/, "")
  : "http://localhost:3002";

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
    localStorage.clear();
    window.location.href = `${SITE_URL}?logged_out=1`;
  }, []);

  return <LogoLoader message="Logging out…" />;
};

export default Logout
